`Copyright 2022 Bio-Conversion Databank Foundation

Licensed under the Apache License, Version 2.0(the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License`;

import UserPool from '@/plugins/UserPool';

export const state = {
  userAttributes: {},
  session: {},
  editUserTab: '',
};

export const mutations = {
  SET_USER_ATTRIBUTES(state, value) {
    state.userAttributes = value;
  },
  SET_SESSION(state, value) {
    state.session = value;
  },
  SET_EDIT_USER_TAB(state, value) {
    state.editUserTab = value;
  },
};

export const actions = {
  getSession({ commit, dispatch }) {
    const user = UserPool.getCurrentUser();
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          console.log('authentication failed: ', session); // DEBUG
        } else {
          commit('SET_SESSION', session);
          commit('SET_USER_ATTRIBUTES', session.idToken.payload);
        }
      });
    } else {
      console.log('authentication failed: user is undefined'); // DEBUG
    }
  },
  logout({ commit }) {
    const user = UserPool.getCurrentUser();
    if (user) {
      user.signOut();
    }
    localStorage.clear();
    sessionStorage.clear();
  },
  setEditUserTab({ commit }, value) {
    commit('SET_EDIT_USER_TAB', value);
  },
};

export const getters = {
  isAdmin(state) {
    let groups = state.userAttributes['cognito:groups'];
    if (!groups || !groups.includes('Admin')) {
      return false;
    } else {
      return true;
    }
  },
  canAccessGEM(state) {
    if (state.userAttributes['custom:gem-client'] == 'true') {
      return true;
    } else {
      return false;
    }
  },
  getJWTToken(state) {
    return state?.session?.idToken?.jwtToken;
  },
};
